import { Get } from "../../../../../Request";

export const GetData = async (pageNumber, limit = 15, filter) => {
  return await Get({
    url: "/report_bug/admin_list",
    data: {
      limit: limit,
      ...filter,
    },

    page: pageNumber,
  }).then(data => {
    return data;
  });
};
